<section class="testimonials">
  <div class="container">

    <span class="subtitle">{{ 'users_review_grid.subtitle' | translate }}</span>

    <h2>{{ 'users_review_grid.title' | translate }}</h2>

    <p class="description">
      {{ 'users_review_grid.description' | translate }}
    </p>

    <div class="testimonial-grid">

      @for (review of reviews; track review) {
        <article class="testimonial-card">
          <div class="stars">★★★★★</div>

          <p>{{ review.desc }}</p>

          <div class="author">
            <div class="avatar">{{ review.avatar }}</div>

            <div>
              <strong>{{ review.user }}</strong>
              <span>{{ review.profession }}</span>
            </div>
          </div>
        </article>
      }

      <!--
          <article class="testimonial-card">
        <div class="stars">★★★★★</div>

        <p>
          "The resume builder is intuitive and the templates look professional.
          I finished my resume in less than 20 minutes."
        </p>

        <div class="author">
          <div class="avatar">A</div>

          <div>
            <strong>Alex M.</strong>
            <span>Software Engineer</span>
          </div>
        </div>
      </article>

      <article class="testimonial-card">
        <div class="stars">★★★★★</div>

        <p>
          "The ATS checker helped me improve my resume before applying.
          I received interview invitations much faster."
        </p>

        <div class="author">
          <div class="avatar">S</div>

          <div>
            <strong>Sarah L.</strong>
            <span>Marketing Manager</span>
          </div>
        </div>
      </article>

      <article class="testimonial-card">
        <div class="stars">★★★★★</div>

        <p>
          "Beautiful templates, easy editing and PDF export.
          Everything worked exactly as expected."
        </p>

        <div class="author">
          <div class="avatar">D</div>

          <div>
            <strong>Daniel K.</strong>
            <span>Graphic Designer</span>
          </div>
        </div>
      </article>

      <article class="testimonial-card">
        <div class="stars">★★★★★</div>

        <p>
          "I uploaded my old resume and updated it in minutes.
          Much easier than starting from scratch."
        </p>

        <div class="author">
          <div class="avatar">E</div>

          <div>
            <strong>Emma R.</strong>
            <span>Business Analyst</span>
          </div>
        </div>
      </article>

      <article class="testimonial-card">
        <div class="stars">★★★★★</div>

        <p>
          "Clean interface, fast editing and no unnecessary complexity.
          Highly recommended."
        </p>

        <div class="author">
          <div class="avatar">J</div>

          <div>
            <strong>James T.</strong>
            <span>Project Manager</span>
          </div>
        </div>
      </article>

      <article class="testimonial-card">
        <div class="stars">★★★★★</div>

        <p>
          "The AI suggestions helped me write stronger bullet points and
          improve my professional summary."
        </p>

        <div class="author">
          <div class="avatar">M</div>

          <div>
            <strong>Maria P.</strong>
            <span>HR Specialist</span>
          </div>
        </div>
      </article>-->

    </div>

    <div class="d-flex jc-c">
      <a
        class="add-review-btn"
        href="https://www.trustpilot.com/review/selfcv.com"
        target="_blank"
        rel="noopener">
        {{ 'users_review_grid.add_review' | translate }}
      </a>
    </div>

  </div>
</section>
